import { Component, OnInit, inject } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { ActivatedRoute } from '@angular/router';
import { SellerInfo } from 'src/app/common/SellerInfo';
import { Location } from '@angular/common';
import { CustomSellerInfoComponent } from '../custom-seller-info/custom-seller-info.component';

@Component({
    imports: [CustomSellerInfoComponent],
    selector: 'app-seller-info',
    templateUrl: './seller-info.component.html',
    styleUrls: ['./seller-info.component.css']
})
export class SellerInfoComponent implements OnInit {
  private customerService = inject(CustomerService);
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);

  private customerId: string;
  public customer: SellerInfo;

  ngOnInit(): void {
    this.customerId = this.activatedRoute.snapshot.queryParamMap.get('customerId');
    this.customerService.getSellerInfoByCustomerId(this.customerId).subscribe({
      next: (customer: SellerInfo) => {
        this.customer = customer;
      },
    });
  }

  onBackClicked() {
    this.location.back();
  }
}
